export default class OEWA {
    _tracker;
    _trackIndex;

    /**
     * @param {string} trackingPixel - The owea tracking pixel url
     */
    constructor(trackingPixel) {
        this._tracker = trackingPixel;
        this._trackIndex = -1;
    }

    get trackIndex() {
        return this._trackIndex;
    }

    /**
     * track an url or event
     * @param {string} type - The type of track
     * @param {*} payload - The tracking payload
     * @param {number} trackIndex - The index of the track event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    track(type, payload, trackIndex) {
        this._trackIndex = trackIndex;
        if (type === 'event') {
            return this._trackEvent();
        } else if(type === 'page') {
            return this._trackPage();
        }
    }

    /**
     * track an url
     * @param {string} url - The url of the page
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackPage() {
        return new Promise((resolve, reject) => {
            const el = document.createElement('img');
            el.src = this._tracker;
            el.style.width = '1px';
            el.style.height = '1px';
            if (document.body) {
                document.body.appendChild(el);
            }
            el.addEventListener("load", () => {
                resolve(true);
                setTimeout(() => {
                    el.parentNode && el.parentNode.removeChild(el);
                }, 100);
            });
        })
    }

    /**
     * track an event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackEvent() {
        //TODO is there event tracking in oewa?
        return Promise.resolve(true);
    }

    /**
     * destroy the tracker instance and clean up if necessary
     */
    destroy() {

    }

    /**
     * repeat calls to this function will not discover the same tracker again
     * @returns - A promise resolving an array of wrapper instances for discovered tracker
     */
    static discover() {
        return Promise.resolve([])
    }

    /**
     * initialize general purpose things like the tracker's library js
     */
    static init() {
        return Promise.resolve();
    }

    /**
     * @param {*} options - The tracker options 
     * @returns - A promise resolving the wrapper instance
     */
    static create({url}) {
        return new Promise((resolve, reject) => {
            resolve(new OEWA(url))
        })
    }
}


// WEBPACK FOOTER //
// ./lib/analytics/tracker-oewa.js